import { useNavigate } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  const navigate = useNavigate();
  return (
    <article
      onClick={() => navigate(`/comic/${comic.id}`)}
      className="group cursor-pointer overflow-hidden rounded-lg border border-background-300/60 bg-background-50 transition-shadow hover:shadow-md"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}古风漫画封面`}
          title={`${comic.title} - ${comic.tag}古风国漫`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        {comic.isHot && (
          <span className="absolute left-2 top-2 rounded-full bg-primary-500 px-2 py-0.5 text-xs font-semibold text-background-50">
            热播
          </span>
        )}
        {comic.isNew && (
          <span className="absolute left-2 top-2 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50">
            新番
          </span>
        )}
        <span className="absolute bottom-2 right-2 rounded bg-foreground-950/70 px-2 py-0.5 text-xs text-background-100">
          {comic.status}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600">
          {comic.title}
        </h3>
        <div className="mt-1.5 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-400"></i>
            {comic.rating}
          </span>
          <span>{comic.chapters}话</span>
        </div>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {comic.intro}
        </p>
      </div>
    </article>
  );
}